import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCircleCheck,
	faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";

const AlertMessage = ({ open, message, type, onClose }) => {
	return (
		<Snackbar
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			open={open}
			onClose={onClose}
			autoHideDuration={6000}
		>
			<Alert severity={type}>{message}</Alert>
		</Snackbar>
	);
};

export default AlertMessage;
